import { Navigate, useLocation } from "react-router-dom";

/**
 * A retired Entity assets path, sent to the one that replaced it.
 *
 * Two of them exist. `/entities/assets/editor` was renamed off the collision
 * with @breakingthelines/editor, the rich text editor in studio and the pages
 * CMS. `/entities/assets/artwork` was a third subtab until the artwork rows
 * moved in beside the text ones, under Corrections. Anything already pointing
 * at either keeps working through here.
 *
 * THE QUERY STRING COMES ALONG. `?id=<entityId>` is the cross-tab load contract
 * (see entity-editor.tsx), so a bare <Navigate to="/..."/> would land an old
 * link on an empty picker instead of the entity it names.
 */
export function QueryPreservingRedirect({ to }: { to: string }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
